// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d9909c5d","790":"c43fd475","799":"e42efed5"}[chunkId] + ".chunk.js";
};